// extracted by mini-css-extract-plugin
export var formContainer = "_mk-0";
export var message = "_mk-1";